import { inject, Injectable } from '@angular/core';
import { AppSettings } from '../app.settings';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { CustomResponse } from '../interfaces/custom-response.model';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  constructor() { }

  private apiEndpoint: string = AppSettings.settings.apiServer.backend;
  http = inject(HttpClient);

  getDashboardOrderList(page: number = 0) : Observable<CustomResponse>
  {
    let url = `${this.apiEndpoint}/dashboard/orderlist`

    if (page > 0)
    {
      url += "?page=" + page;
    }

    return this.http.get<CustomResponse>(url);
  }

  getDashboardInvoiceList(page: number = 0) : Observable<CustomResponse>
  {
    let url = `${this.apiEndpoint}/dashboard/invoicelist`

    if (page > 0)
    {
      url += "?page=" + page;
    }

    return this.http.get<CustomResponse>(url);
  }

  getDashboardCreditnoteList(page: number = 0) : Observable<CustomResponse>
  {
    let url = `${this.apiEndpoint}/dashboard/creditnotelist`

    if (page > 0)
    {
      url += "?page=" + page;
    }

    return this.http.get<CustomResponse>(url);
  }

  
  getDashboardCustomerList(page: number = 0, startchar: string = "", pagesize: number = 50) : Observable<CustomResponse>
  {
    let url = `${this.apiEndpoint}/dashboard/customerlist`

    if (page > 0)
    {
      url += "?page=" + page;
    }

    let data = {
      "pageSize" : pagesize,
      "startsWith" : startchar
    }

    return this.http.post<CustomResponse>(url, data);
  }



}
